// @core/stores/booking/BookingBookingTypeStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  BookingTypeDefinitionResponse,
  ListBookingTypesResponse,
  RegisterBookingTypeRequest,
  UpdateBookingTypeRequest,
} from '@core/types/booking';

class BookingBookingTypeStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Delete booking type
   */
  async DeleteBookingType(type_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.DeleteBookingType(type_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get booking type
   */
  async GetBookingType(type_id: string): Promise<BookingTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.GetBookingType(type_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List booking types
   */
  async ListBookingTypes(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; product_id?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListBookingTypesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ListBookingTypes(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Register booking type
   */
  async RegisterBookingType(data: RegisterBookingTypeRequest): Promise<BookingTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.RegisterBookingType(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update booking type
   */
  async UpdateBookingType(type_id: string, data: UpdateBookingTypeRequest): Promise<BookingTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.UpdateBookingType(type_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingBookingTypeStore = new BookingBookingTypeStore();
